exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.action[data-v-0e7206bb]{margin-right:5px!important}.caption[data-v-0e7206bb]{font-size:.8rem}", ""]);

// exports
